/* eslint-disable import/prefer-default-export */
export const selectToasts = store => store.toasts;
